import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-441671fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "code-box" }
const _hoisted_2 = { style: {"text-align":"right"} }
const _hoisted_3 = { class: "json-code" }
const _hoisted_4 = { class: "helper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_codemirror = _resolveComponent("codemirror")!
  const _component_Reading = _resolveComponent("Reading")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_checkbox, {
        disabled: !_ctx.edit,
        modelValue: _ctx.locked,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.locked) = $event))
      }, {
        default: _withCtx(() => [
          _createTextVNode("只读")
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_codemirror, {
        onChange: _ctx.handleChange,
        disabled: _ctx.locked,
        modelValue: _ctx.jsonVal,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.jsonVal) = $event)),
        placeholder: "输入协议模版格式 ……",
        style: {"width":"100%","height":"100%"},
        autofocus: true,
        "indent-with-tab": true,
        "tab-size": 2,
        extensions: _ctx.extensions
      }, null, 8, ["onChange", "disabled", "modelValue", "extensions"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_link, {
        class: "item",
        underline: false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_icon, { style: {"margin-right":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_Reading)
            ]),
            _: 1
          }),
          _createTextVNode(" 协议文档 ")
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        onClick: _ctx.beautify,
        type: "success"
      }, {
        default: _withCtx(() => [
          _createTextVNode("格式化")
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}